import AccountContext from 'context/AccountContext';
import { useContext, useMemo } from 'react';
import { useActiveElementStore } from 'stores/activeElementStore';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import useGetLoyaltyPermitFreeTimes from './useGetLoyaltyPermitFreeTimes';

const findPermit = (permit: UnifiedPermit, parkZoneUid: string) => {
  if (permit?.parkingZoneUid) {
    return permit.parkingZoneUid === parkZoneUid;
  }
  return permit?.salesLocation?.parkingZones?.includes(parkZoneUid);
};

const useCurrentLicensePlateFreeTime = () => {
  const {
    customer: { permits },
  } = useContext(AccountContext);

  const parkZoneUid = useActiveElementStore((state) => state.activeElement);

  const permit = useMemo(() => {
    return permits?.find((permit) => findPermit(permit, parkZoneUid));
  }, [parkZoneUid, permits]);

  const freeTimes = useGetLoyaltyPermitFreeTimes(permit);
  return freeTimes?.selectedVehicleWithFreeTime;
};

export default useCurrentLicensePlateFreeTime;
